import {
  construirHojaTabla,
  descargarLibro,
  limpiarNombreArchivo,
  texto,
  identificador,
  numero,
} from "../../../Components/ExcelTablaReporte";
import { metrosTotalesPieza, piezasOrdenadasPorPlaca, totalesPiezas } from "./piezasPreCotizacion";

const COLUMNAS = [
  { titulo: "Nombre del proyecto", tipo: "texto", ancho: 28 },
  // Identificador: un número de parte puramente numérico no debe salir en notación
  // científica ni perder ceros a la izquierda.
  { titulo: "Número de parte", tipo: "identificador", ancho: 18 },
  { titulo: "Material", tipo: "texto", ancho: 36 },
  { titulo: "Metros por pieza", tipo: "numero", ancho: 14 },
  { titulo: "Cantidad de piezas", tipo: "numero", ancho: 14 },
  { titulo: "Metros totales", tipo: "numero", ancho: 14 },
];

const conResalte = (celda) => ({ ...celda, resalte: "subtotal" });

/**
 * La tabla del desglose con el estilo de Excel de Biwo. El TOTAL va como renglón propio
 * dentro de `filas`: `totalizar` solo suma columnas de dinero y les pondría formato de
 * moneda a las piezas y a los metros.
 */
export const construirTablaDesglose = (piezas = [], filasCotizacion = []) => {
  const ordenadas = piezasOrdenadasPorPlaca(piezas, filasCotizacion);
  const totales = totalesPiezas(piezas);

  const filas = ordenadas.map(({ pieza, material }) => [
    texto(pieza.nombreProyecto),
    identificador(pieza.numeroParte),
    texto(material),
    numero(pieza.metrosPorPieza),
    numero(pieza.cantidad),
    numero(metrosTotalesPieza(pieza)),
  ]);

  if (filas.length > 0) {
    filas.push(
      [texto("TOTAL"), texto(""), texto(""), texto(""), numero(totales.cantidad), numero(totales.metros)].map(
        conResalte
      )
    );
  }

  return { columnas: COLUMNAS, filas, totales: [], registros: ordenadas.length };
};

export const exportarDesglosePiezas = ({ piezas, filasCotizacion, serie, numero: folio, nombreProyecto, empresaNombre }) => {
  const { columnas, filas, totales, registros } = construirTablaDesglose(piezas, filasCotizacion);
  const folioTexto = [serie, folio].filter((parte) => parte !== undefined && parte !== null && parte !== "").join(" ");

  const hoja = construirHojaTabla(
    { columnas, filas, totales },
    {
      titulo: "Desglose de piezas",
      empresaNombre,
      descripcionFiltros: [folioTexto ? `Pre cotización ${folioTexto}` : "Pre cotización", nombreProyecto]
        .filter(Boolean)
        .join(" · "),
      registros,
      // El TOTAL va dentro de las filas: con autofiltro se iría con los renglones filtrados.
      sinAutofiltro: true,
    }
  );

  descargarLibro(
    [{ nombre: "Desglose de piezas", hoja }],
    limpiarNombreArchivo(`Desglose_piezas_${serie || ""}${folio || ""}`) || "Desglose_piezas"
  );
};
